// import React, {Fragment} from 'react';

const beaches = {
  primaryMenu: [
    {
      label: 'Resorts',
      link: '//www.beaches.com/resorts'
    },
    {
      label: 'Inclusions',
      subLabel: '& Activities',
      link: '//www.beaches.com/all-inclusive/'
    },
    {
      label: 'For Everyone',
      link: '//www.beaches.com/destinations/'
    },
    {
      label: 'Weddings',
      subLabel: '& Honeymoons',
      link: '//www.beaches.com/weddingmoons/'
    },
    {
      label: 'Specials',
      link: '//www.beaches.com/specials/'
    }
  ],
  secondaryMenu: [
    {
      label: 'Rewards Program',
      link: '//www.beaches.com/about/rewards-program/'
    },
    {
      label: 'Sandals Foundation',
      link: '//www.beaches.com/sandals-foundation/'
    },
    {
      label: 'Our Brands',
      link: '//www.beaches.com/about/resort-family/'
    },
    {
      label: 'Eco Friendly',
      link: '//www.beaches.com/about/eco-friendly/'
    },
    {
      label: 'Request Brochure',
      link: '//www.beaches.com/contact/request-brochure/'
    }
  ],
  menuBlocks: {
    resorts: [
      {
        resortName: 'Turks & Caicos',
        resortRegion: 'Providenciales, turks & Caicos',
        link: '//www.beaches.com/resorts/turks-caicos/',
        img: '//cdn.sandals.com/beaches/v12/images/globals/resorts/rst_btc.jpg'
      },
      {
        resortName: 'Negril',
        resortRegion: 'Negrils, Jamaica',
        link: '//www.beaches.com/resorts/negril/',
        img: '//cdn.sandals.com/beaches/v12/images/globals/resorts/rst_bng.jpg'
      },
      {
        resortName: 'Ocho Rios',
        resortRegion: 'Ocho Rios, Jamaica',
        link: '//www.beaches.com/resorts/ocho-rios/',
        img: '//cdn.sandals.com/beaches/v12/images/globals/resorts/rst_bbo.jpg'
      }
    ],
    inclusions: [
      {
        className: 'top-menu',
        heading: {
          label: 'What\'s Included',
          link: '//www.beaches.com/all-inclusive/',
        },
        links: [
          {
            label: 'View All Inclusions',
            link: '//www.beaches.com/all-inclusive/'
          },
          {
            label: 'Accommodations',
            link: '//www.beaches.com/all-inclusive/accommodations/'
          },
          {
            label: 'Butler Service',
            link: '//www.beaches.com/all-inclusive/butler-service/'
          },
          {
            label: 'Concierge Service',
            link: '//www.beaches.com/all-inclusive/concierge-service/'
          },
          {
            label: 'Sesame Street®',
            link: '//www.beaches.com/activities/sesame-street/'
          },
          {
            label: 'Kids Camp',
            link: '//www.beaches.com/activities/kids-camp/'
          },
          {
            label: 'Gourmet Dining',
            link: '//www.beaches.com/all-inclusive/dining/'
          },
          {
            label: 'Premium Spirits',
            link: '//www.beaches.com/all-inclusive/premium-drinks/'
          },
          {
            label: 'Premium House Wines',
            link: '//www.beaches.com/all-inclusive/robert-mondavi/'
          },
          {
            label: 'Entertainment',
            link: '//www.beaches.com/activities/entertainment/'
          },
          {
            label: 'Club Liquid',
            link: '//www.beaches.com/activities/club-liquid/'
          },
          {
            label: 'Xbox Play Lounge',
            link: '//www.beaches.com/activities/xbox/'
          },
          {
            label: 'Scuba Diving',
            link: '//www.beaches.com/scuba/'
          },
          {
            label: 'Water Sports',
            link: '//www.beaches.com/activities/watersports/'
          },
          {
            label: 'Land Sports',
            link: '//www.beaches.com/activities/land-sports/'
          },
          {
            label: 'Golf at Beaches',
            link: '//www.beaches.com/activities/golf/'
          },
          {
            label: 'Waterparks',
            link: '//www.beaches.com/activities/waterparks/'
          },
          {
            label: 'Trench Town',
            link: '//www.beaches.com/activities/trenchtown/'
          }
        ]
      },
      {
        className: 'bottom-menu',
        heading: {
          label: 'Vacation Extras',
          link: '//www.beaches.com/extras/',
        },
        links: [
          {
            label: 'Red Lane® Spa *',
            link: '//www.beaches.com/redlane-spa/'
          },
          {
            label: 'Local Adventure Tools *',
            link: '//www.beaches.com/tours/'
          },
          {
            label: 'Candlelight dinner *',
            link: '//www.beaches.com/activities/candlelight-dinner/'
          },
          {
            label: 'Photo & Video Services *',
            link: '//www.beaches.com/photo-video-services/'
          },
          {
            label: 'LIV+ Events *',
            link: '//www.beaches.com/liv-plus/'
          },
          {
            label: 'Sesame Street VIP *',
            link: '//www.beaches.com/activities/sesame-street/'
          }
        ],
        additionalInformation: '* Available at additional cost'
      }
    ],
    forEveryone: {
      heading: 'Luxury Included® Vacations',
      subHeading: 'for everyone',
      links: [
        {
          label: 'Babies & Toddiers',
          link: '//www.beaches.com/vacation/toddlers/'
        },
        {
          label: 'Kids',
          link: '//www.beaches.com/vacation/kids/'
        },
        {
          label: 'Tweens',
          link: '//www.beaches.com/vacation/tweens/'
        },
        {
          label: 'Teens',
          link: '//www.beaches.com/vacation/teens/'
        },
        {
          label: 'Parents',
          link: '//www.beaches.com/vacation/parents/'
        },
        {
          label: 'Family Reunions',
          link: '//www.beaches.com/vacation/families/'
        },
        {
          label: 'Couples in Love',
          link: '//www.beaches.com/vacation/couples/'
        },
        {
          label: 'Best Friends',
          link: '//www.beaches.com/deals/bff/'
        },
        {
          label: 'Groups',
          link: '//www.beaches.com/groups/'
        }
      ]
    },
    weddings: {
      leftMenu: {
        heading: {
          label: 'Weddings',
          link: '//www.beaches.com/weddings-honeymoons',
        },
        links: [
          {
            label: 'Overview',
            link: '//www.beaches.com/weddings-honeymoons/'
          },
          {
            label: 'Be Inspired',
            link: '//www.beaches.com/weddings/inspirations/'
          },
          {
            label: 'Décor Items',
            link: '//www.beaches.com/weddings/ideas/wishlist-catalog/'
          },
          {
            label: 'Look Books',
            link: '//www.beaches.com/weddings/ideas/look-book/'
          },
          {
            label: 'Inclusions',
            link: '//www.beaches.com/weddings/inclusions/'
          },
          {
            label: 'Locations',
            link: '//www.beaches.com/weddings/venues/'
          },
          {
            label: 'Your guests',
            link: '//www.beaches.com/weddings/guests/'
          },
          {
            label: 'Planning',
            link: '//www.beaches.com/weddings/planner/'
          },
          {
            label: 'Free Wedding',
            link: '//www.beaches.com/weddings/free/'
          },
          {
            label: 'Photo & Video',
            link: '//www.beaches.com/weddings/media-packages/'
          },
          {
            label: 'Menu Options',
            link: '//www.beaches.com/weddings/free/'
          },
          {
            label: 'Entertainment',
            link: '//www.beaches.com/weddings/entertainment/'
          },
          {
            label: 'Wedding FAQs',
            link: '//www.beaches.com/weddings/faqs/'
          }
        ]
      },
      rightMenu: [
        {
          label: 'Engagements',
          link: '//www.beaches.com/engagements'
        },
        {
          label: 'Honeymoons',
          link: '//www.beaches.com/honeymoons/'
        },
        {
          label: 'Anniversaries',
          link: '//www.beaches.com/anniversaries/'
        },
        {
          label: 'Retie the Knot',
          link: '//www.beaches.com/vow-renewals/'
        }
      ],
      weddingPromotionLink: '//www.beaches.com/weddings/promotions/',
      createOwnWeddingLink: '//www.beaches.com/weddings/ideas/'
    },
    specials: {
      heading: {
        label: 'Specials at Sandals',
        link: '//www.beaches.com/deals/',
      },
      links: [
        // {
        //   link: '//www.beaches.com/deals/',
        //   label: 'All Specials at Beaches'
        // },
        {
          link: '//www.beaches.com/deals/resort-specials/',
          label: 'Specials by Resort'
        },
        {
          link: '//www.beaches.com/deals/best-value-suites/',
          label: '777 Offer'
        },
        {
          link: '//www.beaches.com/deals/booking-bonus/',
          label: '$355 Booking Bonus'
        },
        {
          link: '//www.beaches.com/deals/last-minute-travel-deals/',
          label: 'Last Minute Deals'
        },
        {
          link: '//www.beaches.com/deals/fall-4-beaches/',
          label: 'Exclusive Fall Offer'
        },
        {
          link: '//www.beaches.com/deals/free-night/',
          label: 'Free Night'
        },
        {
          link: '//www.beaches.com/deals/firefighter-military-police-savings/',
          label: 'Service Personnel Discount'
        },
        {
          link: '//www.beaches.com/groups/group-specials/',
          label: 'Group (5+Rooms) Specials'
        },
        {
          link: '//www.beaches.com/weddings/promotions/',
          label: 'Weddings Specials'
        }
      ],
      homePage: '//www.beaches.com/specials/'
    }
  },
  includes: {
    fastLinks: [
      {
        url: '//www.beaches.com/about/resort-family/',
        iconClassName: 'icon-fat-pin',
        heading: 'Our Destinations',
        description: 'On the Caribbean\'s Best Beaches'
      },
      {
        url: '//www.beaches.com/compare/',
        iconClassName: 'icon-compare',
        heading: 'Compare Resorts',
        description: 'Our resorts are uniquely different'
      },
    ]
  }
};

export default beaches;



// WEBPACK FOOTER //
// ./js/modules/menuData/beaches.js